import Account from '../views/account/AccountView';

export default [
    {
        path: '/profile',
        exact: false,
        key: 'profile',
        component: Account
    }
];
